import Pusher, { ChannelAuthorizationCallback } from 'pusher-js'
import { post } from 'common/HTTPClient'

let pusherInstance: Pusher | null = null

export function getPusherClient(): Pusher {
  if (!pusherInstance) {
    pusherInstance = new Pusher(process.env.REACT_APP_PUSHER_KEY!, {
      cluster: process.env.REACT_APP_PUSHER_CLUSTER!,
      channelAuthorization: {
        endpoint: '/pusher/auth',
        transport: 'ajax',
        customHandler: async (
          { socketId, channelName }: { socketId: string; channelName: string },
          callback: ChannelAuthorizationCallback
        ) => {
          try {
            const response = await post('/pusher/auth', {
              socket_id: socketId,
              channel_name: channelName,
            })
            callback(null, response.data)
          } catch (error) {
            callback(error as Error, null)
          }
        },
      },
    })
  }
  return pusherInstance
}
